import { HorizontalScrollView } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { useOrientationBannerText } from "@src/appV2/ClipboardOrientation/hooks/useOrientationBannerText";
import {
  type BannerName,
  type BannerProps,
  BANNERS,
} from "@src/appV2/redesign/Accounts/Banners/AccountPageBanner";
import { useAssessmentsBannerText } from "@src/appV2/SkillsAssessment/utils/useAssessmentsBannerText";

interface AccountPageBannersContainerProps {
  workerId: string;
  bannersToSkip?: BannerName[];
}

export function AccountPageBannersContainer(props: AccountPageBannersContainerProps) {
  const { workerId, bannersToSkip = [] } = props;

  const { orientationBannerText, isOrientationBannerTextLoading } = useOrientationBannerText({
    workerId,
  });
  const assessmentsBannerText = useAssessmentsBannerText({ workerId });

  const bannerProps: BannerProps = {
    workerId,
    bannersToSkip,
    orientationBannerText,
    isOrientationBannerTextLoading,
    assessmentsBannerText,
  };

  return (
    <Box sx={{ paddingBottom: 4, marginX: -5 }}>
      <HorizontalScrollView
        stretch
        sx={{
          px: 5,
        }}
      >
        {BANNERS.map((Banner) => (
          <Banner key={Banner.name} {...bannerProps} />
        ))}
      </HorizontalScrollView>
    </Box>
  );
}
